import { Authenticator, HttpService, RequestConfig } from '../httpClient';

export class BaseApiClient<T = unknown> {
  protected readonly http: HttpService;

  constructor(urlPrefix: string, authenticator?: Authenticator) {
    this.http = new HttpService(urlPrefix, authenticator);
  }

  /**
   * NOTE: if you need params then implement custom find() method in descendant
   */
  async getAll(options: RequestConfig = {}): Promise<T[]> {
    return await this.http.get<T[]>('', {
      params: {
        populate: '*',
      },
      ...options,
    });
  }

  async getOne<R = T>(id: number | string, signal?: AbortSignal, options?: RequestConfig): Promise<R> {
    return await this.http.get<R>(`/${encodeURIComponent(id)}`, {
      params: {
        populate: '*',
      },
      ...options,
      signal,
    });
  }

  async create(body: unknown, signal?: AbortSignal): Promise<T> {
    return await this.http.post<T>('', body, { signal });
  }

  async update(id: number | string, body: unknown, signal?: AbortSignal): Promise<T> {
    return await this.http.put<T>(`/${encodeURIComponent(id)}`, body, { signal });
  }

  async delete(id: number | string, signal?: AbortSignal): Promise<T> {
    return await this.http.delete<T>(`/${encodeURIComponent(id)}`, { signal });
  }
}
